import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gio-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {

  @Input()
  type = 'simple';

  @Input()
  percentage: 0;



  @Input()
  colors: any[] = [{
    to: 25,
    color: '#0058e9'
  }, {
    from: 25,
    to: 50,
    color: '#37b400'
  }, {
    from: 50,
    to: 75,
    color: '#ffc000'
  }, {
    from: 75,
    color: '#f31700'
  }];

  constructor() { }

  ngOnInit() {
  }

}
